import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-pitch" data-id="element-58" data-mp="c70xva6rjfok">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-59" data-mp="c4fuuhuqatp8">
        <h2 id="cierre" className="font-display text-[1.8rem] font-normal uppercase leading-none text-gold sm:text-5xl" data-id="element-60" data-mp="83m83rt0vkxx">
          Una última oportunidad
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/85" data-id="element-61" data-mp="h5c6xip8hm5q">
          Puedes seguir guardando videos de ejercicios, tácticas, formaciones y
          entrenamientos sin saber cómo organizar una sesión completa. O puedes
          comenzar hoy a construir tus conocimientos como entrenador siguiendo
          una ruta organizada desde cero.
        </p>
        <p className="mx-auto mt-1.5 max-w-xl font-sub text-sm font-extrabold leading-snug text-white" data-id="element-62" data-mp="zx4s4qy2a32w">
          No necesitas saberlo todo sobre fútbol para empezar.{' '}
          <span className="text-gold" data-id="element-63" data-mp="2h3hnymusku5b">Necesitas dar el primer paso.</span>
        </p>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-gold bg-white p-3 text-pitch" data-id="element-64" data-mp="2m2ua15du9x6u">
          <p className="font-sub text-sm font-extrabold uppercase leading-tight text-field" data-id="element-65" data-mp="2r1xh0vddqdhg">
            {PRODUCT_NAME}
          </p>
          <p className="mt-1 inline-block rounded-md bg-gold px-2 py-0.5 font-display text-2xl uppercase leading-tight" data-id="element-66" data-mp="2v2hdrxu1jf32">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-xs font-semibold text-pitch/80 sm:text-sm" data-id="element-67" data-mp="34tc35b2l2usq">
            Valor de los bonos:{' '}
            <span className="line-through decoration-red-600 decoration-2" data-id="element-68" data-mp="39sybb63k1kuo">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-1 font-display text-6xl leading-none text-field sm:text-7xl" data-id="element-69" data-mp="3esb0hxhwf40f">
            <span className="text-3xl text-pitch sm:text-4xl" data-id="element-70" data-mp="3islhe578beu2">Hoy:</span>{' '}
            {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-71" data-mp="1jnjwpshlj2ls">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 text-xs font-semibold text-pitch/80" data-id="element-72" data-mp="1er3d9blcdcf1">
            Acceso Inmediato • Entrega Digital • Garantía de 7 Días
          </p>
        </Reveal>
      </div>
    </section>;
}